import { extendTheme } from '@chakra-ui/react';
import { Button } from './components/Button';
import { colors } from './components/colors';
import { fonts } from './components/font';
import { Input } from './components/Input';
import { Select } from './components/Select';
import { Text } from './components/Text';

const overrides = {
  colors,
  fonts,
  components: {
    Select,
    Button,
    Input,
    Text,
  },
};

export default extendTheme(overrides);
